import ResetPasswordView from "./ResetPasswordView";
export default ResetPasswordView;